import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import SimpleDropdown from '~/modules/common/components/SimpleDropdown';
import { noChange } from '~/modules/common/hooks';

const label = (
  <FormattedMessage id="massEditProject.projectManagerTimesheetApproval" />
);

const getOptions = intl => [
  noChange(intl),
  {
    id: 'noApproval',
    displayText: intl.formatMessage({ id: 'massEditProject.noApproval' })
  },
  {
    id: 'required',
    displayText: intl.formatMessage({ id: 'massEditProject.required' })
  }
];

const selectProps = {
  labelId: 'timesheet-approval-dropdown-label',
  id: 'timesheet-approval-dropdown',
  SelectDisplayProps: {
    role: 'listbox'
  }
};

const inputLabelProps = {
  id: 'timesheet-approval-dropdown-label'
};

export const TimeSheetApprovalDropdown = ({ value, onChange }) => {
  const intl = useIntl();
  const options = getOptions(intl);

  return (
    <SimpleDropdown
      variant="filled"
      label={label}
      noneOption={false}
      options={options}
      onChange={onChange}
      value={value}
      disableSort
      selectProps={selectProps}
      inputLabelProps={inputLabelProps}
    />
  );
};

TimeSheetApprovalDropdown.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
};

export default TimeSheetApprovalDropdown;
